<template>
    <div class="py-4"> 
        <div id="assessment-remaining-date" class="mb-5">
            <div class="mb-2 tail-line-dark-sm">
                {{ $t('남은 기간') }}
            </div>
            <div v-if="check_campaign_completed === false && is_nice_services_status_loaded === true"
                class="f-90"
                :class="[{ 'red': left_days < 1 }]"
                > 
                <span class="f-160">{{ left_days }}</span>
                {{ $i18n.locale === 'ko' ? '일' : 'days' }}
                
                <span class="ml-1 f-160"> {{ left_time }}</span>
                {{ $i18n.locale === 'ko' ? '시간' : 'hours' }}
            </div>
            <div v-else class="f-90 gray-550">
                - {{ $t('답변기간이 아닙니다') }} -
            </div>
        </div>

        <div id="assessment-submit" class="mb-5">
            <div class="mb-2 tail-line-dark-sm"> {{ $t('최종 제출하기') }} </div>
            <make-all-complete-button
                :btn_size="'sm'"
                :btn_variant="variant_by_filled_rate"
                :disable_status="status_code !== 'in_progress'"
                >
                <fa icon="flag" class="mr-1"></fa>
                <span v-if="status_code === 'requested'">{{ $t('미시작') }}</span>
                <span v-else-if="status_code === 'in_progress'">{{ $t('최종 제출하기') }}</span>
                <span v-else-if="status_code === 'in_assessment'">{{ $t('평가중') }}</span>
                <span v-else-if="status_code === 'canceled'">{{ $t('평가 취소') }}</span>
                <span v-else>{{ $t('평가완료') }}</span>
                <!-- {{ status_code === 'in_progress' ? $t('최종 제출하기') : $t('제출됨') }}
                {{ status_code === 'in_assessment'? $t('평가중') : ''}} -->
            </make-all-complete-button>

            <div v-if="overall_filled === true && check_campaign_completed === false"
                class="f-85 mt-2"
                :class="overall_filled === true ? 'red red-border' : 'gray-600'">
                <fa icon="info-circle" class="mr-1"></fa>
                {{ $t('답변을 모두 완료하셨다면 최종 제출하기를 클릭해주세요.') }}
            </div>
            <div v-else-if="check_campaign_completed === true" class="f-85 gray-600 mt-2">
                <fa icon="grin-alt" class="mr-1 f-90"></fa>
                {{ $t('제출되었습니다. 감사합니다.') }}
            </div>
        </div>

        <div v-if="!is_loading_participants" class="mb-5">
            <div class="mb-2 tail-line-dark-sm">{{ $t('참여자 리스트') }}</div>
            <div id="participant-list" :class="[{ 'mb-2': is_manager }]">
                <div v-for="(participant, index) in participants"
                    :key="`company-user-${participant.id}`"
                    class="mb-2"
                    >
                    <p class="f-95 mb-0">{{ index + 1 }}. {{ participant.user.user_name }}
                        <b-badge :variant="participant.role === 2 ? 'primary' : 'basic'" class="ml-1"> 
                            <span v-if="participant.role === 2">
                                {{ $t('평가 관리자') }}
                            </span>
                            <span v-else-if="participant.role === 1 && participant.access_status === 0">
                                {{ $t('일반 참여자') }}
                            </span>
                            <span v-else>
                                {{ $t('접근 요청중') }}
                            </span>
                        </b-badge>
                    </p>
                    <p class="f-85 text-truncate mb-0 ml-3">{{ participant.user.e_mail }}</p>
                </div>
            </div>
            <div v-if="is_manager">
                <b-button
                    v-b-modal.user-registration
                    variant="dark-border"
                    size="sm"
                    >
                    <fa icon="user-plus" class="mr-1"></fa>
                    {{ $t('참여자 관리') }}
                </b-button>
            </div>
        </div>

        <div class="mb-5">
            <div class="mb-2 tail-line-dark-sm">{{ $t('첨부파일 관리') }}</div>
            <b-button v-b-modal.company-attachements-storage
                variant="dark-border"
                size="sm"
                >
                <BIconUpload class="mr-1"/>
                {{ $t('첨부파일 보관함') }}
            </b-button>
        </div>
        
        
        <div class="mb-2 tail-line-dark-sm">{{ $t('인쇄 및 다운로드') }}</div>
        <div v-if="isIE !== true" class="mb-5">
            <print-to-pdf :btn_size="'sm'">
                <fa icon="print" class="mr-1"></fa> {{ $t('인쇄 및 다운로드') }}
            </print-to-pdf>
        </div>

        <div v-else class="mb-5 border border-color-gray-400 bgray-300 rounded p-2 p-xl-3 f-85 gray-600">
            <fa icon="info-circle" class="mr-1"></fa>
            {{ $t('인터넷 익스플로러에서는 인쇄 및 다운로드를 사용하실 수 없습니다. 크롬(Chrome) 또는 엣지(Edge) 브라우저를 사용해주세요.') }} 
        </div>

        <b-modal id="company-attachements-storage" size="xl" :title="$t('첨부파일 보관함')" hide-footer scrollable>
            <AttachmentsStorage />
        </b-modal>
        
        <template v-if="is_manager">
            <b-modal id="user-registration" size="lg" :title="$t('참여자 수정하기')" hide-footer scrollable>
                <user-registration-form
                    :users_in_company="participants"
                    :is_manager="is_manager"
                    @update-user="updateUser"
                    @update-members="updateMembers"
                    />
            </b-modal>
        </template>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations} from 'vuex';
import PrintToPDF from '@core_components/common/PrintToPDF';
import MakeAllCompleteButton from '@shared_components/client/components/MakeAllCompleteButton';
import UserRegistrationForm from '@shared_components/client/components/UserRegistrationForm_v2';
import AttachmentsStorage from '@shared_components/client/components/AttachmentsStorage';
import {checkAppEnv} from '@shared/utils/common';

export default {
    components: {
        'print-to-pdf': PrintToPDF,
        MakeAllCompleteButton,
        UserRegistrationForm,
        AttachmentsStorage
    },
    data () {
        return {
            is_loading_participants: true,
            participants: []
        };
    },
    computed:{
        ...mapState(['campaign_in_progress', 'is_admin', 'company_id', 'user_id', 'question_in_progress']),
        ...mapState('campaign_users', ['users_in_company']),
        ...mapState('industry_campaigns', ['nice_services_status', 'is_nice_services_status_loaded', 'total_filled_rate', 'is_filled_rate_loaded']),
        ...mapState({
            status_code: state => state.campaign_in_progress.status_code
        }),
        check_campaign_completed () {
            if (this.campaign_in_progress.campaign_state === '답변중' && this.status_code === 'in_progress') {
                return false;
            } else if (this.status_code === 'in_assessment') {
                return true;
            } else if (this.status_code === 'completed') {
                return true;
            } else {
                return null;
            }
        },
        left_days () {
            if (this.is_nice_services_status_loaded == true && this.nice_services_status.length) {
                if (this.isIE === true) {
                    let txt_date = this.nice_services_status[0].duedate_ts.replace('-', '/');
                    let gap = new Date(txt_date).getTime() - new Date().getTime();
                    return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수
                } else {
                    let gap = new Date(this.nice_services_status[0].duedate_ts).getTime() - new Date().getTime();
                    return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수 
                }
            } else {
                return null;
            }            
        },
        left_time () {
            if (this.is_nice_services_status_loaded == true && this.nice_services_status.length) {
                if (this.isIE === true) {
                    let txt_date = this.nice_services_status[0].duedate_ts.replace('-', '/');
                    let time_gap = new Date(0, 0, 0, 0, 0, 0, new Date(txt_date) - new Date()); 
                    return time_gap.getHours(); // 남은 시간
                } else {
                    let time_gap = new Date(0, 0, 0, 0, 0, 0, new Date(this.nice_services_status[0].duedate_ts) - new Date()); 
                    return time_gap.getHours(); // 남은 시간
                }
            } else {
                return null;
            }
        },
        question_code() {
            return this.question_in_progress.question_code;
        },
        overall_filled() {
            if (this.is_filled_rate_loaded == true && this.total_filled_rate.length) {
                if ((this.total_filled_rate[0].filled_rate*100) >80){
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        variant_by_filled_rate(){
            if (this.is_filled_rate_loaded == true) {
                if (this.overall_filled == true && this.status_code == 'in_progress') {
                    return 'red-blinking';
                } else {
                    return (checkAppEnv() === 'ksteel' || checkAppEnv() === 'supply') ? 'primary' : 'outline-dark';
                }
            } else {
                return (checkAppEnv() === 'ksteel' || checkAppEnv() === 'supply') ? 'primary' : 'outline-dark';
            }
        },
        is_manager () {
            if (!this.participants || !this.participants.length) {
                return false;
            } else {
                const _me = this.participants.find(_participant => _participant.user_id === Number(this.user_id));
                return _me.role === 2;
            }
        }
    },
    watch:{
        question_code:{
            immediate: true,
            async handler (newV) {
                if (newV) {
                    await this.readFilledRate({
                        campaign_id: this.$route.query.cmp,
                        company_id: this.$route.query.cpn
                    });
                }
            }
        }
    },
    async created () {
        await this.readNiceServiceStatus({
            campaign_id: this.$route.query.cmp,
            company_id: this.$route.query.cpn
        });

        // if (!this.users_in_company || !this.users_in_company.length) {
        //     await this.readUsersByCompany(this.company_id)    
        // }

        await this.getRequestParticipants();
    },
    beforeDestroy(){
        this.update_filled_rate_loaded(false);
    },
    methods:{
        ...mapMutations('industry_campaigns', ['update_filled_rate_loaded']),
        ...mapActions('industry_campaigns', ['readNiceServiceStatus', 'readFilledRate']),
        ...mapActions('campaign_users', ['readUsersByCompany']),
        async getRequestParticipants () {
            try {
                this.is_loading_participants = true;
                const res_member = await this.$axios.get('/company/members', {
                    params: {
                        company_id: this.$route.query.cpn,
                        campaign_id: this.$route.query.cmp
                    }
                });
                this.participants = res_member.data.sort((a, b) => b.role - a.role);
            } catch (e) {
                console.log(' ~ e => ', e); 
            } finally {
                this.is_loading_participants = false;
            }
        },
        checkUserExcluded(user_excluded_campaigns){
            if (user_excluded_campaigns) {
                let excluded_idx = user_excluded_campaigns.findIndex( exc => exc == this.campaign_in_progress.campaign_name);
                return excluded_idx > -1;
            } else {
                return false;
            }
        },
        updateUser (updatedUser) {
            let _updating_target_user_idx = this.participants.find(({ user_id }) => user_id === updatedUser.user_id);
            this.participants[_updating_target_user_idx] = updatedUser;
        },
        updateMembers (updatedMembers) {
            this.participants = updatedMembers.sort((a, b) => b.role - a.role);
        }
    }
};
</script>

<style>

</style>
